import Home from './views/home'
import Login from './views/login'
import Plans from './views/plans'
import SignUp from './views/signUp'
import QrCodes from './views/lists/qrCodes'
import Dashboard from './views/dashboard'
import Settings from './views/settings'
import Links from './views/lists/links'
import CreateNewLink from './views/createNew/link'
import Index from './views/index'
import LinkDetail from './views/details/links'
import QrCodeDetail from './views/details/qrCodes'
import CreateNewQr from './views/createNew/qr'

interface Route {
  path: string
  Component: React.ComponentType<any>
}

const routes: Route[] = [
  {
    path: '/',
    Component: Index,
  },
  {
    path: '/plans',
    Component: Plans,
  },
  {
    path: '/login',
    Component: Login,
  },
  {
    path: '/sign-up',
    Component: SignUp,
  },
  {
    path: '/create-new-link',
    Component: CreateNewLink,
  },
  {
    path: '/create-new-qr-code',
    Component: CreateNewQr,
  },
  // {
  //   path: '/custom-links',
  //   Component: CustomLinks,
  // },
  {
    path: '/links',
    Component: Links,
  },
  {
    path: '/links/:id',
    Component: LinkDetail,
  },
  {
    path: '/qr-codes',
    Component: QrCodes,
  },
  {
    path: '/qr-codes/:id',
    Component: QrCodeDetail,
  },
  {
    path: '/dashboard',
    Component: Dashboard,
  },
  {
    path: '/settings',
    Component: Settings,
  },
]

export default routes
